var UnsubscribeInput = /** @class */ (function () {
    function UnsubscribeInput(input) {
        this.lineIds = [];
        this.input = input;
    }
    UnsubscribeInput.prototype.toggleLine = function (lineId) {
        var i = this.lineIds.indexOf(lineId);
        if (i == -1) {
            this.lineIds.push(lineId);
        }
        else {
            this.lineIds.splice(i, 1);
        }
        this.writeValue();
    };
    UnsubscribeInput.prototype.addLine = function (lineId) {
        if (this.lineIds.indexOf(lineId) == -1) {
            this.lineIds.push(lineId);
        }
        this.writeValue();
    };
    UnsubscribeInput.prototype.removeLine = function (lineId) {
        var i = this.lineIds.indexOf(lineId);
        if (i != -1) {
            this.lineIds.splice(i, 1);
        }
        this.writeValue();
    };
    /**
     * Updates the HTMLInputElement value
     */
    UnsubscribeInput.prototype.writeValue = function () {
        this.input.value = this.lineIds.join(',');
    };
    return UnsubscribeInput;
}());
export default UnsubscribeInput;
